import { createFileRoute, Link } from '@tanstack/react-router'
import { ShieldAlert } from 'lucide-react'
import { useAuthStore } from '@/hooks/auth/useAuthStore'
import { getEntryPath } from '@/config/routes'

function ForbiddenPage() {
  const role = useAuthStore((s) => s.user?.roles?.[0])

  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <ShieldAlert className="h-12 w-12 text-red-500" />
      <h1 className="mt-4 text-xl font-semibold text-gray-900 dark:text-white">Access denied</h1>
      <p className="mt-2 max-w-sm text-sm text-gray-500 dark:text-gray-400">
        Your account doesn't have the role required to view that page. If you think this is wrong, ask an admin to
        update your role.
      </p>
      <Link
        to={getEntryPath(role)}
        className="mt-6 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
      >
        Back to your dashboard
      </Link>
    </div>
  )
}

export const Route = createFileRoute('/(admin)/403/')({ component: ForbiddenPage })
